/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { Authentication } from 'Authentication/Authentication';
import CurrentUserInformation from 'Authentication/CurrentUserInformation';
import { getSessionId } from 'requests/sessionId';
import { v4 as uuidv4 } from 'uuid';
import * as moment from 'moment';

export class BaseClient {
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    options.headers = new Headers({
      'Content-Type': 'application/json;',
      Accept: 'application/json',
      Authorization: `Bearer ${await Authentication.Instance.GetToken()}`,
      'sekoia.session_id': getSessionId(),
      'sekoia.correlation_id': uuidv4(),
      'sekoia.customer_id': CurrentUserInformation.Instance.getUserInformation().customerId,
    });

    return options;
  }

  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REACT_APP_OBSERVATIONS_SERVICE_URL) {
      throw new Error('OBSERVATIONS_SERVICE_URL must be set in environment');
    }

    return process.env.REACT_APP_OBSERVATIONS_SERVICE_URL;
  }
}

export class PingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    ping(): Promise<string> {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    throw(): Promise<string> {
        let url_ = this.baseUrl + "/api/throw";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processThrow(_response);
        });
    }

    protected processThrow(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class StepClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createStep(formId: string, createStepRequest: CreateStepRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createStepRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateStep(_response);
        });
    }

    protected processCreateStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getSteps(formId: string, excludeExtendedByResidents: boolean | undefined): Promise<StepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (excludeExtendedByResidents === null)
            throw new Error("The parameter 'excludeExtendedByResidents' cannot be null.");
        else if (excludeExtendedByResidents !== undefined)
            url_ += "excludeExtendedByResidents=" + encodeURIComponent("" + excludeExtendedByResidents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSteps(_response);
        });
    }

    protected processGetSteps(response: Response): Promise<StepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StepResponse[]>(<any>null);
    }

    updateSteps(formId: string, updateStepsRequest: UpdateStepsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateStepsRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSteps(_response);
        });
    }

    protected processUpdateSteps(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteStep(formId: string, stepId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteStep(_response);
        });
    }

    protected processDeleteStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getResidentExtendedSteps(formId: string, extendedByResidentId: string): Promise<StepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/extendedByResidents/{extendedByResidentId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (extendedByResidentId === undefined || extendedByResidentId === null)
            throw new Error("The parameter 'extendedByResidentId' must be defined.");
        url_ = url_.replace("{extendedByResidentId}", encodeURIComponent("" + extendedByResidentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentExtendedSteps(_response);
        });
    }

    protected processGetResidentExtendedSteps(response: Response): Promise<StepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StepResponse[]>(<any>null);
    }
}

export class RegistrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createRegistration(residentId: string | null, body: CreateRegistrationRequestBody): Promise<RegistrationIdResponse> {
        let url_ = this.baseUrl + "/api/registrations/{residentId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistration(_response);
        });
    }

    protected processCreateRegistration(response: Response): Promise<RegistrationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationIdResponse>(<any>null);
    }

    getRegistrations(residentId: string | null, formId: string, countToTake: number | undefined): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/forms/{formId}/registrations?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (countToTake === null)
            throw new Error("The parameter 'countToTake' cannot be null.");
        else if (countToTake !== undefined)
            url_ += "countToTake=" + encodeURIComponent("" + countToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrations(_response);
        });
    }

    protected processGetRegistrations(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }

    getRegistrationsForPeriod(from: moment.Moment | undefined, planId: string, residentId: string | null, to: moment.Moment | undefined): Promise<RegistrationWithoutAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/residents/{ResidentId}/plans/{PlanId}/period?";
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{PlanId}", encodeURIComponent("" + planId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{ResidentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForPeriod(_response);
        });
    }

    protected processGetRegistrationsForPeriod(response: Response): Promise<RegistrationWithoutAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationWithoutAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationWithoutAnswersResponse[]>(<any>null);
    }

    getRegistrationsForResidents(getRegistrationsRequest: GetRegistrationsRequest): Promise<RegistrationWithoutAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getRegistrationsRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForResidents(_response);
        });
    }

    protected processGetRegistrationsForResidents(response: Response): Promise<RegistrationWithoutAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationWithoutAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationWithoutAnswersResponse[]>(<any>null);
    }

    getRegistrationsReport(request: GetRegistrationsReportRequest): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/observations/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsReport(_response);
        });
    }

    protected processGetRegistrationsReport(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }
}

export class KarunaFormClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    getFormsWithAssignmentsIncluded(residentId: string | null, clientLocalDate: moment.Moment | undefined): Promise<FormStepResponse[]> {
        let url_ = this.baseUrl + "/api/karuna/forms/includeAssignments/{residentId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (clientLocalDate === null)
            throw new Error("The parameter 'clientLocalDate' cannot be null.");
        else if (clientLocalDate !== undefined)
            url_ += "clientLocalDate=" + encodeURIComponent(clientLocalDate ? "" + clientLocalDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithAssignmentsIncluded(_response);
        });
    }

    protected processGetFormsWithAssignmentsIncluded(response: Response): Promise<FormStepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormStepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse[]>(<any>null);
    }
}

export class KarunaRegistrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createRegistration(residentId: string | null, body: CreateRegistrationRequestBody2): Promise<RegistrationIdResponse> {
        let url_ = this.baseUrl + "/api/karuna/registrations/{residentId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistration(_response);
        });
    }

    protected processCreateRegistration(response: Response): Promise<RegistrationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationIdResponse>(<any>null);
    }
}

export class InternalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    getFoldersForCustomer(customerId: string | null): Promise<FolderResponse[]> {
        let url_ = this.baseUrl + "/api/internal/folders/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFoldersForCustomer(_response);
        });
    }

    protected processGetFoldersForCustomer(response: Response): Promise<FolderResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponse[]>(<any>null);
    }

    copyFolder(request: CopyFoldersAndContentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folder/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFolder(_response);
        });
    }

    protected processCopyFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FormClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createForm(createFormRequest: CreateFormRequest): Promise<CreateFormIdResponse> {
        let url_ = this.baseUrl + "/api/forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFormRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateForm(_response);
        });
    }

    protected processCreateForm(response: Response): Promise<CreateFormIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateFormIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateFormIdResponse>(<any>null);
    }

    getForms(includeArchived: boolean | undefined, ownerId: string | null | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "OwnerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForms(_response);
        });
    }

    protected processGetForms(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormPlanList(formId: string | null): Promise<string[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/planlist";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormPlanList(_response);
        });
    }

    protected processGetFormPlanList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    getFormPlanListByResident(formId: string | null, residentId: string | null): Promise<string[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/residents/{residentId}/planlist";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormPlanListByResident(_response);
        });
    }

    protected processGetFormPlanListByResident(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    getFormsByResidentAndPlan(residentId: string | null, planId: string | null, includeArchived: boolean | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsByResidentAndPlan(_response);
        });
    }

    protected processGetFormsByResidentAndPlan(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    updatePlanAndResidentRelations(residentId: string | null, planId: string, requestBody: UpdatePlanAndResidentRelationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePlanAndResidentRelations(_response);
        });
    }

    protected processUpdatePlanAndResidentRelations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getFormsForResidentAndPlanInPeriod(residentId: string | null, planId: string, from: moment.Moment | undefined, to: moment.Moment | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}/period?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForResidentAndPlanInPeriod(_response);
        });
    }

    protected processGetFormsForResidentAndPlanInPeriod(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsByIdBatch(request: GetFormsByIdBatchRequest): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/byid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsByIdBatch(_response);
        });
    }

    protected processGetFormsByIdBatch(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsForOwnersBatch(request: GetFormsForOwnersBatchRequest): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForOwnersBatch(_response);
        });
    }

    protected processGetFormsForOwnersBatch(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsForOwnersBatchInternal(request: GetFormsForOwnersBatchInternalRequest): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/batch/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForOwnersBatchInternal(_response);
        });
    }

    protected processGetFormsForOwnersBatchInternal(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsForResidentWithStepsAndChoicesIncluded(residentId: string | null, registrationCountDate: moment.Moment | undefined): Promise<FormStepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/includeStepsAndChoices?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationCountDate === null)
            throw new Error("The parameter 'registrationCountDate' cannot be null.");
        else if (registrationCountDate !== undefined)
            url_ += "RegistrationCountDate=" + encodeURIComponent(registrationCountDate ? "" + registrationCountDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForResidentWithStepsAndChoicesIncluded(_response);
        });
    }

    protected processGetFormsForResidentWithStepsAndChoicesIncluded(response: Response): Promise<FormStepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormStepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse[]>(<any>null);
    }

    getFormWithStepsAndChoicesFilteredDownToResident(residentId: string | null, formId: string | null, includeInactiveForm: boolean | undefined, includeArchived: boolean | undefined): Promise<FormStepResponse> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/includeStepsAndChoices/{formId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (includeInactiveForm === null)
            throw new Error("The parameter 'includeInactiveForm' cannot be null.");
        else if (includeInactiveForm !== undefined)
            url_ += "includeInactiveForm=" + encodeURIComponent("" + includeInactiveForm) + "&";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormWithStepsAndChoicesFilteredDownToResident(_response);
        });
    }

    protected processGetFormWithStepsAndChoicesFilteredDownToResident(response: Response): Promise<FormStepResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormStepResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse>(<any>null);
    }

    getFormsWithAssignmentsIncluded(residentId: string | null, includeArchived: boolean | undefined): Promise<FormAssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/includeAssignments/{residentId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithAssignmentsIncluded(_response);
        });
    }

    protected processGetFormsWithAssignmentsIncluded(response: Response): Promise<FormAssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormAssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormAssignmentResponse[]>(<any>null);
    }

    getFormsWithAssignmentsIncludedByQuery(bodyRequest: GetFormsWithAssignmentsIncludedByQueryBodyRequest): Promise<FormAssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/includeAssignments/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bodyRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithAssignmentsIncludedByQuery(_response);
        });
    }

    protected processGetFormsWithAssignmentsIncludedByQuery(response: Response): Promise<FormAssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormAssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormAssignmentResponse[]>(<any>null);
    }

    getFormWithStepsAndChoicesIncluded(formId: string | null): Promise<FormStepResponse> {
        let url_ = this.baseUrl + "/api/forms/{formId}/includeStepsAndChoices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormWithStepsAndChoicesIncluded(_response);
        });
    }

    protected processGetFormWithStepsAndChoicesIncluded(response: Response): Promise<FormStepResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormStepResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse>(<any>null);
    }

    setFormArchivedStatus(formId: string, setFormArchivedStatusRequest: SetFormArchivedStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/updatearchived";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setFormArchivedStatusRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFormArchivedStatus(_response);
        });
    }

    protected processSetFormArchivedStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateForm(formId: string, updateFormRequest: UpdateFormRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/form/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm(_response);
        });
    }

    protected processUpdateForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setFutureAssignmentsOnForm(formId: string, request: SetFutureAssignmentsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/futureresidentsassignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFutureAssignmentsOnForm(_response);
        });
    }

    protected processSetFutureAssignmentsOnForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssignedForFutureResidentsForForm(formId: string | null): Promise<AssignedForFutureResidentsResponse> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignedForFutureResidents";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignedForFutureResidentsForForm(_response);
        });
    }

    protected processGetAssignedForFutureResidentsForForm(response: Response): Promise<AssignedForFutureResidentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedForFutureResidentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignedForFutureResidentsResponse>(<any>null);
    }

    getEmployeeActivatedForms(request: FormsQueryRequest[]): Promise<FormStepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeActivatedForms(_response);
        });
    }

    protected processGetEmployeeActivatedForms(response: Response): Promise<FormStepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormStepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse[]>(<any>null);
    }

    copyForms(request: CopyFormsRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/forms/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyForms(_response);
        });
    }

    protected processCopyForms(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class FolderClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createFolder(request: CreateFolderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getFolders(): Promise<FolderResponse[]> {
        let url_ = this.baseUrl + "/api/folders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFolders(_response);
        });
    }

    protected processGetFolders(response: Response): Promise<FolderResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponse[]>(<any>null);
    }

    updateFolder(folderId: string, updateFolderRequest: UpdateFolderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFolderRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFolder(_response);
        });
    }

    protected processUpdateFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteFolder(folderId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFolder(_response);
        });
    }

    protected processDeleteFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ChoiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createChoice(formId: string, stepId: string, createChoiceRequest: CreateChoiceRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createChoiceRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChoice(_response);
        });
    }

    protected processCreateChoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateChoices(formId: string, stepId: string, updateChoicesRequest: UpdateChoicesRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateChoicesRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateChoices(_response);
        });
    }

    protected processUpdateChoices(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteChoice(formId: string, stepId: string, choiceId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices/{choiceId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteChoice(_response);
        });
    }

    protected processDeleteChoice(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AssignmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    deleteAssignment(formId: string, residentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments/{residentId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignment(_response);
        });
    }

    protected processDeleteAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateAssignment(formId: string, residentId: string | null, assignmentRequest: AssignmentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments/{residentId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignmentRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssignment(_response);
        });
    }

    protected processUpdateAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteAssignmentsBulk(formId: string, requestFromBody: DeleteAssignmentBulkRequest): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestFromBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignmentsBulk(_response);
        });
    }

    protected processDeleteAssignmentsBulk(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(<any>null);
    }

    getResidentsIdsAssignedToFormId(formId: string): Promise<AssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsIdsAssignedToFormId(_response);
        });
    }

    protected processGetResidentsIdsAssignedToFormId(response: Response): Promise<AssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentResponse[]>(<any>null);
    }

    updateAssignmentsBulk(formId: string, requestFromBody: UpdateAssignmentsBulkRequest): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestFromBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssignmentsBulk(_response);
        });
    }

    protected processUpdateAssignmentsBulk(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(<any>null);
    }

    getResidentsIdsAssignedToFormIdsBulk(request: GetResidentsIdsAssignedToFormIdsBulkRequest): Promise<{ [key: string]: AssignmentResponse[]; }> {
        let url_ = this.baseUrl + "/api/forms/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsIdsAssignedToFormIdsBulk(_response);
        });
    }

    protected processGetResidentsIdsAssignedToFormIdsBulk(response: Response): Promise<{ [key: string]: AssignmentResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => AssignmentResponse.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: AssignmentResponse[]; }>(<any>null);
    }

    assignFormsEnabledForFutureResidentsToResident(residentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignformsfornewresident";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignFormsEnabledForFutureResidentsToResident(_response);
        });
    }

    protected processAssignFormsEnabledForFutureResidentsToResident(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AnswerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    getAnswers(residentId: string | null, registrationId: string | null, registeredAt: moment.Moment | undefined): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/registrations/{registrationId}/answers?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        if (registeredAt === null)
            throw new Error("The parameter 'registeredAt' cannot be null.");
        else if (registeredAt !== undefined)
            url_ += "registeredAt=" + encodeURIComponent(registeredAt ? "" + registeredAt.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswers(_response);
        });
    }

    protected processGetAnswers(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }

    getAnswers2(registrationId: string | null): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/{registrationId}/answers";
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswers2(_response);
        });
    }

    protected processGetAnswers2(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }

    getAnswersByResidentsIdsBatch(answerBatchRequestBody: AnswerBatchRequestBody): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/answers/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(answerBatchRequestBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswersByResidentsIdsBatch(_response);
        });
    }

    protected processGetAnswersByResidentsIdsBatch(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }
}

export class CreateStepRequest implements ICreateStepRequest {
    extendedByResidentId?: string | null;
    multiSelectEnabled!: boolean;
    scoreEnabled!: boolean;
    required!: boolean;
    commentEnabled!: boolean;
    stepType!: string;
    title?: string | null;
    unit?: string | null;

    constructor(data?: ICreateStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extendedByResidentId = _data["extendedByResidentId"] !== undefined ? _data["extendedByResidentId"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoreEnabled = _data["scoreEnabled"] !== undefined ? _data["scoreEnabled"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.stepType = _data["stepType"] !== undefined ? _data["stepType"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): CreateStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extendedByResidentId"] = this.extendedByResidentId !== undefined ? this.extendedByResidentId : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoreEnabled"] = this.scoreEnabled !== undefined ? this.scoreEnabled : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["stepType"] = this.stepType !== undefined ? this.stepType : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data; 
    }
}

export interface ICreateStepRequest {
    extendedByResidentId?: string | null;
    multiSelectEnabled: boolean;
    scoreEnabled: boolean;
    required: boolean;
    commentEnabled: boolean;
    stepType: string;
    title?: string | null;
    unit?: string | null;
}

export class StepResponse implements IStepResponse {
    choices!: ChoiceResponse[];
    extendedByResidentId!: string;
    id!: string;
    multiSelectEnabled!: boolean;
    order!: number;
    scoringEnabled!: boolean;
    commentEnabled!: boolean;
    title!: string;
    type!: StepType;
    required!: boolean;
    description?: string | null;
    descriptiveImagePath?: string | null;
    unit?: string | null;
    equation?: string | null;

    constructor(data?: IStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.choices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceResponse.fromJS(item));
            }
            else {
                this.choices = <any>null;
            }
            this.extendedByResidentId = _data["extendedByResidentId"] !== undefined ? _data["extendedByResidentId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.equation = _data["equation"] !== undefined ? _data["equation"] : <any>null;
        }
    }

    static fromJS(data: any): StepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["extendedByResidentId"] = this.extendedByResidentId !== undefined ? this.extendedByResidentId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["equation"] = this.equation !== undefined ? this.equation : <any>null;
        return data; 
    }
}

export interface IStepResponse {
    choices: ChoiceResponse[];
    extendedByResidentId: string;
    id: string;
    multiSelectEnabled: boolean;
    order: number;
    scoringEnabled: boolean;
    commentEnabled: boolean;
    title: string;
    type: StepType;
    required: boolean;
    description?: string | null;
    descriptiveImagePath?: string | null;
    unit?: string | null;
    equation?: string | null;
}

export class ChoiceResponse implements IChoiceResponse {
    id!: string;
    order!: number;
    score!: number;
    title!: string;

    protected _discriminator: string;

    constructor(data?: IChoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ChoiceResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ChoiceResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ImageChoiceResponse") {
            let result = new ImageChoiceResponse();
            result.init(data);
            return result;
        }
        let result = new ChoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface IChoiceResponse {
    id: string;
    order: number;
    score: number;
    title: string;
}

export class ImageChoiceResponse extends ChoiceResponse implements IImageChoiceResponse {
    imageUrl!: string;

    constructor(data?: IImageChoiceResponse) {
        super(data);
        this._discriminator = "ImageChoiceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageChoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageChoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IImageChoiceResponse extends IChoiceResponse {
    imageUrl: string;
}

export enum StepType {
    Text = "Text",
    Image = "Image",
    AnswerWithImage = "AnswerWithImage",
    FreeFormText = "FreeFormText",
    Skipped = "Skipped",
    HealthMeasurementBloodGlucose = "HealthMeasurementBloodGlucose",
    HealthMeasurementBloodPressure = "HealthMeasurementBloodPressure",
    HealthMeasurementBodyTemperature = "HealthMeasurementBodyTemperature",
    HealthMeasurementBodyWeight = "HealthMeasurementBodyWeight",
    HealthMeasurementHeartRate = "HealthMeasurementHeartRate",
    HealthMeasurementOxygenSaturation = "HealthMeasurementOxygenSaturation",
    HealthMeasurementRespiratoryRate = "HealthMeasurementRespiratoryRate",
    NumericValue = "NumericValue",
    Calculation = "Calculation",
}

export class UpdateStepsRequest implements IUpdateStepsRequest {
    steps!: Step[];

    constructor(data?: IUpdateStepsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateStepsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStepsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateStepsRequest {
    steps: Step[];
}

export class Step implements IStep {
    id!: string;
    multiSelectEnabled?: boolean | null;
    orderIndex!: number;
    scoringEnabled?: boolean | null;
    title!: string;
    required?: boolean | null;
    commentEnabled?: boolean | null;
    description?: string | null;
    descriptiveImage?: DescriptiveImage | null;
    equation?: string | null;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptiveImage = _data["descriptiveImage"] ? DescriptiveImage.fromJS(_data["descriptiveImage"]) : <any>null;
            this.equation = _data["equation"] !== undefined ? _data["equation"] : <any>null;
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptiveImage"] = this.descriptiveImage ? this.descriptiveImage.toJSON() : <any>null;
        data["equation"] = this.equation !== undefined ? this.equation : <any>null;
        return data; 
    }
}

export interface IStep {
    id: string;
    multiSelectEnabled?: boolean | null;
    orderIndex: number;
    scoringEnabled?: boolean | null;
    title: string;
    required?: boolean | null;
    commentEnabled?: boolean | null;
    description?: string | null;
    descriptiveImage?: DescriptiveImage | null;
    equation?: string | null;
}

export class DescriptiveImage implements IDescriptiveImage {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;

    constructor(data?: IDescriptiveImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagePath = _data["imagePath"] !== undefined ? _data["imagePath"] : <any>null;
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.deleteImage = _data["deleteImage"] !== undefined ? _data["deleteImage"] : <any>null;
        }
    }

    static fromJS(data: any): DescriptiveImage {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptiveImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagePath"] = this.imagePath !== undefined ? this.imagePath : <any>null;
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["deleteImage"] = this.deleteImage !== undefined ? this.deleteImage : <any>null;
        return data; 
    }
}

export interface IDescriptiveImage {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;
}

export class RegistrationIdResponse implements IRegistrationIdResponse {
    registrationId!: string;

    constructor(data?: IRegistrationIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        return data; 
    }
}

export interface IRegistrationIdResponse {
    registrationId: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; } | null;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; } | null;
}

export class CreateRegistrationRequestBody implements ICreateRegistrationRequestBody {
    answers!: AnswerRequest[];
    comment?: string | null;
    taskInstanceId?: string | null;
    taskAssignmentId?: string | null;
    formId!: string;
    observedAt!: moment.Moment;
    employeeIdsToNotify!: string[];

    constructor(data?: ICreateRegistrationRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
            this.employeeIdsToNotify = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerRequest.fromJS(item));
            }
            else {
                this.answers = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.taskInstanceId = _data["taskInstanceId"] !== undefined ? _data["taskInstanceId"] : <any>null;
            this.taskAssignmentId = _data["taskAssignmentId"] !== undefined ? _data["taskAssignmentId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            if (Array.isArray(_data["employeeIdsToNotify"])) {
                this.employeeIdsToNotify = [] as any;
                for (let item of _data["employeeIdsToNotify"])
                    this.employeeIdsToNotify!.push(item);
            }
            else {
                this.employeeIdsToNotify = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateRegistrationRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["taskInstanceId"] = this.taskInstanceId !== undefined ? this.taskInstanceId : <any>null;
        data["taskAssignmentId"] = this.taskAssignmentId !== undefined ? this.taskAssignmentId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        if (Array.isArray(this.employeeIdsToNotify)) {
            data["employeeIdsToNotify"] = [];
            for (let item of this.employeeIdsToNotify)
                data["employeeIdsToNotify"].push(item);
        }
        return data; 
    }
}

export interface ICreateRegistrationRequestBody {
    answers: AnswerRequest[];
    comment?: string | null;
    taskInstanceId?: string | null;
    taskAssignmentId?: string | null;
    formId: string;
    observedAt: moment.Moment;
    employeeIdsToNotify: string[];
}

export abstract class AnswerRequest implements IAnswerRequest {
    choiceId?: string | null;
    order!: number;
    stepId!: string;
    stepComment?: string | null;
    stepTitle?: string | null;

    protected _discriminator: string;

    constructor(data?: IAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
            this.stepComment = _data["stepComment"] !== undefined ? _data["stepComment"] : <any>null;
            this.stepTitle = _data["stepTitle"] !== undefined ? _data["stepTitle"] : <any>null;
        }
    }

    static fromJS(data: any): AnswerRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "TextAnswerRequest") {
            let result = new TextAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "ImageAnswerRequest") {
            let result = new ImageAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AnswerWithImageRequest") {
            let result = new AnswerWithImageRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FreeFormTextAnswerRequest") {
            let result = new FreeFormTextAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SkippedAnswerRequest") {
            let result = new SkippedAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerRequest") {
            let result = new BloodGlucoseAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HealthMeasurementsAnswerRequest") {
            throw new Error("The abstract class 'HealthMeasurementsAnswerRequest' cannot be instantiated.");
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerRequest") {
            let result = new BloodPressureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerRequest") {
            let result = new BodyTemperatureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerRequest") {
            let result = new BodyWeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerRequest") {
            let result = new HeartRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerRequest") {
            let result = new OxygenSaturationAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerRequest") {
            let result = new RespiratoryRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumericValueAnswerRequest") {
            let result = new NumericValueAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CalculationAnswerRequest") {
            let result = new CalculationAnswerRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        data["stepComment"] = this.stepComment !== undefined ? this.stepComment : <any>null;
        data["stepTitle"] = this.stepTitle !== undefined ? this.stepTitle : <any>null;
        return data; 
    }
}

export interface IAnswerRequest {
    choiceId?: string | null;
    order: number;
    stepId: string;
    stepComment?: string | null;
    stepTitle?: string | null;
}

export class TextAnswerRequest extends AnswerRequest implements ITextAnswerRequest {
    choiceOrder!: number;
    choiceScore!: number;
    choiceTitle?: string | null;
    multiSelectEnabled!: boolean;
    scoringEnabled!: boolean;

    constructor(data?: ITextAnswerRequest) {
        super(data);
        this._discriminator = "TextAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.choiceOrder = _data["choiceOrder"] !== undefined ? _data["choiceOrder"] : <any>null;
            this.choiceScore = _data["choiceScore"] !== undefined ? _data["choiceScore"] : <any>null;
            this.choiceTitle = _data["choiceTitle"] !== undefined ? _data["choiceTitle"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): TextAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceOrder"] = this.choiceOrder !== undefined ? this.choiceOrder : <any>null;
        data["choiceScore"] = this.choiceScore !== undefined ? this.choiceScore : <any>null;
        data["choiceTitle"] = this.choiceTitle !== undefined ? this.choiceTitle : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextAnswerRequest extends IAnswerRequest {
    choiceOrder: number;
    choiceScore: number;
    choiceTitle?: string | null;
    multiSelectEnabled: boolean;
    scoringEnabled: boolean;
}

export class ImageAnswerRequest extends AnswerRequest implements IImageAnswerRequest {
    points!: PointsRequest[];

    constructor(data?: IImageAnswerRequest) {
        super(data);
        if (!data) {
            this.points = [];
        }
        this._discriminator = "ImageAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointsRequest.fromJS(item));
            }
            else {
                this.points = <any>null;
            }
        }
    }

    static fromJS(data: any): ImageAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IImageAnswerRequest extends IAnswerRequest {
    points: PointsRequest[];
}

export class PointsRequest implements IPointsRequest {
    x!: number;
    y!: number;

    constructor(data?: IPointsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
        }
    }

    static fromJS(data: any): PointsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PointsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        return data; 
    }
}

export interface IPointsRequest {
    x: number;
    y: number;
}

export class AnswerWithImageRequest extends AnswerRequest implements IAnswerWithImageRequest {
    images!: ImageRequest[];

    constructor(data?: IAnswerWithImageRequest) {
        super(data);
        if (!data) {
            this.images = [];
        }
        this._discriminator = "AnswerWithImageRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageRequest.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerWithImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerWithImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAnswerWithImageRequest extends IAnswerRequest {
    images: ImageRequest[];
}

export class ImageRequest implements IImageRequest {
    data!: string;

    constructor(data?: IImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data; 
    }
}

export interface IImageRequest {
    data: string;
}

export class FreeFormTextAnswerRequest extends AnswerRequest implements IFreeFormTextAnswerRequest {
    freeFormText!: string;

    constructor(data?: IFreeFormTextAnswerRequest) {
        super(data);
        this._discriminator = "FreeFormTextAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.freeFormText = _data["freeFormText"] !== undefined ? _data["freeFormText"] : <any>null;
        }
    }

    static fromJS(data: any): FreeFormTextAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeFormText"] = this.freeFormText !== undefined ? this.freeFormText : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextAnswerRequest extends IAnswerRequest {
    freeFormText: string;
}

export class SkippedAnswerRequest extends AnswerRequest implements ISkippedAnswerRequest {

    constructor(data?: ISkippedAnswerRequest) {
        super(data);
        this._discriminator = "SkippedAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SkippedAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkippedAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISkippedAnswerRequest extends IAnswerRequest {
}

export class AnswerResponse implements IAnswerResponse {
    id!: string;
    choiceId!: string;
    choiceTitle!: string;
    customerId!: string;
    formId!: string;
    order!: number;
    registrationId!: string;
    stepId!: string;
    stepTitle!: string;
    stepComment!: string;
    stepCommentEnabled!: boolean;

    protected _discriminator: string;

    constructor(data?: IAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.choiceTitle = _data["choiceTitle"] !== undefined ? _data["choiceTitle"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
            this.stepTitle = _data["stepTitle"] !== undefined ? _data["stepTitle"] : <any>null;
            this.stepComment = _data["stepComment"] !== undefined ? _data["stepComment"] : <any>null;
            this.stepCommentEnabled = _data["stepCommentEnabled"] !== undefined ? _data["stepCommentEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): AnswerResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "HealthMeasurementAnswerResponse") {
            let result = new HealthMeasurementAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAnswerResponse") {
            let result = new TextAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "ImageAnswerResponse") {
            let result = new ImageAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AnswerWithImageResponse") {
            let result = new AnswerWithImageResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FreeFormTextAnswerResponse") {
            let result = new FreeFormTextAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SkippedAnswerResponse") {
            let result = new SkippedAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerResponse") {
            let result = new BloodGlucoseAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerResponse") {
            let result = new BloodPressureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerResponse") {
            let result = new BodyTemperatureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerResponse") {
            let result = new BodyWeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerResponse") {
            let result = new HeartRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerResponse") {
            let result = new OxygenSaturationAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerResponse") {
            let result = new RespiratoryRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumericValueAnswerResponse") {
            let result = new NumericValueAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CalculationAnswerResponse") {
            let result = new CalculationAnswerResponse();
            result.init(data);
            return result;
        }
        let result = new AnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["choiceTitle"] = this.choiceTitle !== undefined ? this.choiceTitle : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        data["stepTitle"] = this.stepTitle !== undefined ? this.stepTitle : <any>null;
        data["stepComment"] = this.stepComment !== undefined ? this.stepComment : <any>null;
        data["stepCommentEnabled"] = this.stepCommentEnabled !== undefined ? this.stepCommentEnabled : <any>null;
        return data; 
    }
}

export interface IAnswerResponse {
    id: string;
    choiceId: string;
    choiceTitle: string;
    customerId: string;
    formId: string;
    order: number;
    registrationId: string;
    stepId: string;
    stepTitle: string;
    stepComment: string;
    stepCommentEnabled: boolean;
}

export class HealthMeasurementAnswerResponse extends AnswerResponse implements IHealthMeasurementAnswerResponse {
    healthMeasurementMeasuredAt!: moment.Moment;
    isHealthMeasurementDeleted!: boolean;
    healthMeasurementDeletedReason?: string | null;

    constructor(data?: IHealthMeasurementAnswerResponse) {
        super(data);
        this._discriminator = "HealthMeasurementAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthMeasurementMeasuredAt = _data["healthMeasurementMeasuredAt"] ? moment(_data["healthMeasurementMeasuredAt"].toString()) : <any>null;
            this.isHealthMeasurementDeleted = _data["isHealthMeasurementDeleted"] !== undefined ? _data["isHealthMeasurementDeleted"] : <any>null;
            this.healthMeasurementDeletedReason = _data["healthMeasurementDeletedReason"] !== undefined ? _data["healthMeasurementDeletedReason"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementAnswerResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerResponse") {
            let result = new BloodGlucoseAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerResponse") {
            let result = new BloodPressureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerResponse") {
            let result = new BodyTemperatureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerResponse") {
            let result = new BodyWeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerResponse") {
            let result = new HeartRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerResponse") {
            let result = new OxygenSaturationAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerResponse") {
            let result = new RespiratoryRateAnswerResponse();
            result.init(data);
            return result;
        }
        let result = new HealthMeasurementAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthMeasurementMeasuredAt"] = this.healthMeasurementMeasuredAt ? this.healthMeasurementMeasuredAt.toISOString() : <any>null;
        data["isHealthMeasurementDeleted"] = this.isHealthMeasurementDeleted !== undefined ? this.isHealthMeasurementDeleted : <any>null;
        data["healthMeasurementDeletedReason"] = this.healthMeasurementDeletedReason !== undefined ? this.healthMeasurementDeletedReason : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementAnswerResponse extends IAnswerResponse {
    healthMeasurementMeasuredAt: moment.Moment;
    isHealthMeasurementDeleted: boolean;
    healthMeasurementDeletedReason?: string | null;
}

export class TextAnswerResponse extends AnswerResponse implements ITextAnswerResponse {
    choiceScore!: number;
    multiSelectEnabled!: boolean;
    scoringEnabled!: boolean;
    choiceOrder!: number;

    constructor(data?: ITextAnswerResponse) {
        super(data);
        this._discriminator = "TextAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.choiceScore = _data["choiceScore"] !== undefined ? _data["choiceScore"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.choiceOrder = _data["choiceOrder"] !== undefined ? _data["choiceOrder"] : <any>null;
        }
    }

    static fromJS(data: any): TextAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceScore"] = this.choiceScore !== undefined ? this.choiceScore : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["choiceOrder"] = this.choiceOrder !== undefined ? this.choiceOrder : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextAnswerResponse extends IAnswerResponse {
    choiceScore: number;
    multiSelectEnabled: boolean;
    scoringEnabled: boolean;
    choiceOrder: number;
}

export class ImageAnswerResponse extends AnswerResponse implements IImageAnswerResponse {
    points!: PointResponse[];
    imageUrl!: string;

    constructor(data?: IImageAnswerResponse) {
        super(data);
        if (!data) {
            this.points = [];
        }
        this._discriminator = "ImageAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointResponse.fromJS(item));
            }
            else {
                this.points = <any>null;
            }
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IImageAnswerResponse extends IAnswerResponse {
    points: PointResponse[];
    imageUrl: string;
}

export class PointResponse implements IPointResponse {
    y!: number;
    x!: number;

    constructor(data?: IPointResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
        }
    }

    static fromJS(data: any): PointResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PointResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["x"] = this.x !== undefined ? this.x : <any>null;
        return data; 
    }
}

export interface IPointResponse {
    y: number;
    x: number;
}

export class AnswerWithImageResponse extends AnswerResponse implements IAnswerWithImageResponse {
    images!: ImageResponse[];

    constructor(data?: IAnswerWithImageResponse) {
        super(data);
        if (!data) {
            this.images = [];
        }
        this._discriminator = "AnswerWithImageResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageResponse.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerWithImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerWithImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAnswerWithImageResponse extends IAnswerResponse {
    images: ImageResponse[];
}

export class ImageResponse implements IImageResponse {
    imageUrl!: string;

    constructor(data?: IImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data; 
    }
}

export interface IImageResponse {
    imageUrl: string;
}

export class FreeFormTextAnswerResponse extends AnswerResponse implements IFreeFormTextAnswerResponse {
    freeFormText!: string;

    constructor(data?: IFreeFormTextAnswerResponse) {
        super(data);
        this._discriminator = "FreeFormTextAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.freeFormText = _data["freeFormText"] !== undefined ? _data["freeFormText"] : <any>null;
        }
    }

    static fromJS(data: any): FreeFormTextAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeFormText"] = this.freeFormText !== undefined ? this.freeFormText : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextAnswerResponse extends IAnswerResponse {
    freeFormText: string;
}

export class SkippedAnswerResponse extends AnswerResponse implements ISkippedAnswerResponse {

    constructor(data?: ISkippedAnswerResponse) {
        super(data);
        this._discriminator = "SkippedAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SkippedAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkippedAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISkippedAnswerResponse extends IAnswerResponse {
}

export class BloodGlucoseAnswerResponse extends HealthMeasurementAnswerResponse implements IBloodGlucoseAnswerResponse {
    level!: number;

    constructor(data?: IBloodGlucoseAnswerResponse) {
        super(data);
        this._discriminator = "BloodGlucoseAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): BloodGlucoseAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodGlucoseAnswerResponse extends IHealthMeasurementAnswerResponse {
    level: number;
}

export class BloodPressureAnswerResponse extends HealthMeasurementAnswerResponse implements IBloodPressureAnswerResponse {
    systolic!: number;
    diastolic!: number;

    constructor(data?: IBloodPressureAnswerResponse) {
        super(data);
        this._discriminator = "BloodPressureAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): BloodPressureAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodPressureAnswerResponse extends IHealthMeasurementAnswerResponse {
    systolic: number;
    diastolic: number;
}

export class BodyTemperatureAnswerResponse extends HealthMeasurementAnswerResponse implements IBodyTemperatureAnswerResponse {
    temperature!: number;

    constructor(data?: IBodyTemperatureAnswerResponse) {
        super(data);
        this._discriminator = "BodyTemperatureAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): BodyTemperatureAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyTemperatureAnswerResponse extends IHealthMeasurementAnswerResponse {
    temperature: number;
}

export class BodyWeightAnswerResponse extends HealthMeasurementAnswerResponse implements IBodyWeightAnswerResponse {
    weight!: number;

    constructor(data?: IBodyWeightAnswerResponse) {
        super(data);
        this._discriminator = "BodyWeightAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): BodyWeightAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyWeightAnswerResponse extends IHealthMeasurementAnswerResponse {
    weight: number;
}

export class HeartRateAnswerResponse extends HealthMeasurementAnswerResponse implements IHeartRateAnswerResponse {
    rate!: number;

    constructor(data?: IHeartRateAnswerResponse) {
        super(data);
        this._discriminator = "HeartRateAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): HeartRateAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeartRateAnswerResponse extends IHealthMeasurementAnswerResponse {
    rate: number;
}

export class OxygenSaturationAnswerResponse extends HealthMeasurementAnswerResponse implements IOxygenSaturationAnswerResponse {
    level!: number;

    constructor(data?: IOxygenSaturationAnswerResponse) {
        super(data);
        this._discriminator = "OxygenSaturationAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): OxygenSaturationAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IOxygenSaturationAnswerResponse extends IHealthMeasurementAnswerResponse {
    level: number;
}

export class RespiratoryRateAnswerResponse extends HealthMeasurementAnswerResponse implements IRespiratoryRateAnswerResponse {
    rate!: number;

    constructor(data?: IRespiratoryRateAnswerResponse) {
        super(data);
        this._discriminator = "RespiratoryRateAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RespiratoryRateAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RespiratoryRateAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRespiratoryRateAnswerResponse extends IHealthMeasurementAnswerResponse {
    rate: number;
}

export class NumericValueAnswerResponse extends AnswerResponse implements INumericValueAnswerResponse {
    unit!: string;
    numericValue!: number;

    constructor(data?: INumericValueAnswerResponse) {
        super(data);
        this._discriminator = "NumericValueAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : <any>null;
        }
    }

    static fromJS(data: any): NumericValueAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueAnswerResponse extends IAnswerResponse {
    unit: string;
    numericValue: number;
}

export class CalculationAnswerResponse extends AnswerResponse implements ICalculationAnswerResponse {
    calculatedValue!: number;

    constructor(data?: ICalculationAnswerResponse) {
        super(data);
        this._discriminator = "CalculationAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.calculatedValue = _data["calculatedValue"] !== undefined ? _data["calculatedValue"] : <any>null;
        }
    }

    static fromJS(data: any): CalculationAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedValue"] = this.calculatedValue !== undefined ? this.calculatedValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculationAnswerResponse extends IAnswerResponse {
    calculatedValue: number;
}

export abstract class HealthMeasurementsAnswerRequest extends AnswerRequest implements IHealthMeasurementsAnswerRequest {
    healthMeasurementMeasuredAt!: moment.Moment;

    constructor(data?: IHealthMeasurementsAnswerRequest) {
        super(data);
        this._discriminator = "HealthMeasurementsAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthMeasurementMeasuredAt = _data["healthMeasurementMeasuredAt"] ? moment(_data["healthMeasurementMeasuredAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementsAnswerRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerRequest") {
            let result = new BloodGlucoseAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerRequest") {
            let result = new BloodPressureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerRequest") {
            let result = new BodyTemperatureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerRequest") {
            let result = new BodyWeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerRequest") {
            let result = new HeartRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerRequest") {
            let result = new OxygenSaturationAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerRequest") {
            let result = new RespiratoryRateAnswerRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'HealthMeasurementsAnswerRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthMeasurementMeasuredAt"] = this.healthMeasurementMeasuredAt ? this.healthMeasurementMeasuredAt.toISOString() : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementsAnswerRequest extends IAnswerRequest {
    healthMeasurementMeasuredAt: moment.Moment;
}

export class BloodGlucoseAnswerRequest extends HealthMeasurementsAnswerRequest implements IBloodGlucoseAnswerRequest {
    level?: number | null;

    constructor(data?: IBloodGlucoseAnswerRequest) {
        super(data);
        this._discriminator = "BloodGlucoseAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): BloodGlucoseAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodGlucoseAnswerRequest extends IHealthMeasurementsAnswerRequest {
    level?: number | null;
}

export class BloodPressureAnswerRequest extends HealthMeasurementsAnswerRequest implements IBloodPressureAnswerRequest {
    systolic?: number | null;
    diastolic?: number | null;

    constructor(data?: IBloodPressureAnswerRequest) {
        super(data);
        this._discriminator = "BloodPressureAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): BloodPressureAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodPressureAnswerRequest extends IHealthMeasurementsAnswerRequest {
    systolic?: number | null;
    diastolic?: number | null;
}

export class BodyTemperatureAnswerRequest extends HealthMeasurementsAnswerRequest implements IBodyTemperatureAnswerRequest {
    temperature?: number | null;

    constructor(data?: IBodyTemperatureAnswerRequest) {
        super(data);
        this._discriminator = "BodyTemperatureAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): BodyTemperatureAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyTemperatureAnswerRequest extends IHealthMeasurementsAnswerRequest {
    temperature?: number | null;
}

export class BodyWeightAnswerRequest extends HealthMeasurementsAnswerRequest implements IBodyWeightAnswerRequest {
    weight?: number | null;

    constructor(data?: IBodyWeightAnswerRequest) {
        super(data);
        this._discriminator = "BodyWeightAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): BodyWeightAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyWeightAnswerRequest extends IHealthMeasurementsAnswerRequest {
    weight?: number | null;
}

export class HeartRateAnswerRequest extends HealthMeasurementsAnswerRequest implements IHeartRateAnswerRequest {
    rate?: number | null;

    constructor(data?: IHeartRateAnswerRequest) {
        super(data);
        this._discriminator = "HeartRateAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): HeartRateAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeartRateAnswerRequest extends IHealthMeasurementsAnswerRequest {
    rate?: number | null;
}

export class OxygenSaturationAnswerRequest extends HealthMeasurementsAnswerRequest implements IOxygenSaturationAnswerRequest {
    level?: number | null;

    constructor(data?: IOxygenSaturationAnswerRequest) {
        super(data);
        this._discriminator = "OxygenSaturationAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): OxygenSaturationAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IOxygenSaturationAnswerRequest extends IHealthMeasurementsAnswerRequest {
    level?: number | null;
}

export class RespiratoryRateAnswerRequest extends HealthMeasurementsAnswerRequest implements IRespiratoryRateAnswerRequest {
    rate?: number | null;

    constructor(data?: IRespiratoryRateAnswerRequest) {
        super(data);
        this._discriminator = "RespiratoryRateAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RespiratoryRateAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RespiratoryRateAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRespiratoryRateAnswerRequest extends IHealthMeasurementsAnswerRequest {
    rate?: number | null;
}

export class NumericValueAnswerRequest extends AnswerRequest implements INumericValueAnswerRequest {
    numericValue?: number | null;
    unit!: string;

    constructor(data?: INumericValueAnswerRequest) {
        super(data);
        this._discriminator = "NumericValueAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): NumericValueAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueAnswerRequest extends IAnswerRequest {
    numericValue?: number | null;
    unit: string;
}

export class CalculationAnswerRequest extends AnswerRequest implements ICalculationAnswerRequest {
    calculatedValue?: number | null;

    constructor(data?: ICalculationAnswerRequest) {
        super(data);
        this._discriminator = "CalculationAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.calculatedValue = _data["calculatedValue"] !== undefined ? _data["calculatedValue"] : <any>null;
        }
    }

    static fromJS(data: any): CalculationAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedValue"] = this.calculatedValue !== undefined ? this.calculatedValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculationAnswerRequest extends IAnswerRequest {
    calculatedValue?: number | null;
}

export class RegistrationResponse implements IRegistrationResponse {
    answers!: AnswerResponse[];
    comment!: string;
    createdAt!: moment.Moment;
    customerId!: string;
    formId!: string;
    formTitle!: string;
    observedAt!: moment.Moment;
    registrantId!: string;
    id!: string;
    residentId!: string;
    totalScore!: number;
    scoringEnabled!: boolean;

    constructor(data?: IRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerResponse.fromJS(item));
            }
            else {
                this.answers = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.formTitle = _data["formTitle"] !== undefined ? _data["formTitle"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            this.registrantId = _data["registrantId"] !== undefined ? _data["registrantId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.totalScore = _data["totalScore"] !== undefined ? _data["totalScore"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formTitle"] = this.formTitle !== undefined ? this.formTitle : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        data["registrantId"] = this.registrantId !== undefined ? this.registrantId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["totalScore"] = this.totalScore !== undefined ? this.totalScore : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        return data; 
    }
}

export interface IRegistrationResponse {
    answers: AnswerResponse[];
    comment: string;
    createdAt: moment.Moment;
    customerId: string;
    formId: string;
    formTitle: string;
    observedAt: moment.Moment;
    registrantId: string;
    id: string;
    residentId: string;
    totalScore: number;
    scoringEnabled: boolean;
}

export class RegistrationWithoutAnswersResponse implements IRegistrationWithoutAnswersResponse {
    comment!: string;
    createdAt!: moment.Moment;
    customerId!: string;
    formId!: string;
    formTitle!: string;
    observedAt!: moment.Moment;
    registrantId!: string;
    id!: string;
    residentId!: string;

    constructor(data?: IRegistrationWithoutAnswersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.formTitle = _data["formTitle"] !== undefined ? _data["formTitle"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            this.registrantId = _data["registrantId"] !== undefined ? _data["registrantId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationWithoutAnswersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationWithoutAnswersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formTitle"] = this.formTitle !== undefined ? this.formTitle : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        data["registrantId"] = this.registrantId !== undefined ? this.registrantId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IRegistrationWithoutAnswersResponse {
    comment: string;
    createdAt: moment.Moment;
    customerId: string;
    formId: string;
    formTitle: string;
    observedAt: moment.Moment;
    registrantId: string;
    id: string;
    residentId: string;
}

export class GetRegistrationsRequest implements IGetRegistrationsRequest {
    formIds!: string[];
    fromDate!: moment.Moment;
    residentIds!: string[];
    toDate!: moment.Moment;

    constructor(data?: IGetRegistrationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetRegistrationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        return data; 
    }
}

export interface IGetRegistrationsRequest {
    formIds: string[];
    fromDate: moment.Moment;
    residentIds: string[];
    toDate: moment.Moment;
}

export class GetRegistrationsReportRequest implements IGetRegistrationsReportRequest {
    formIds!: string[];
    fromDate!: moment.Moment;
    residentIds!: string[];
    toDate!: moment.Moment;

    constructor(data?: IGetRegistrationsReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetRegistrationsReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        return data; 
    }
}

export interface IGetRegistrationsReportRequest {
    formIds: string[];
    fromDate: moment.Moment;
    residentIds: string[];
    toDate: moment.Moment;
}

export class FormStepResponse implements IFormStepResponse {
    paused!: boolean;
    archived!: boolean;
    description?: string | null;
    id!: string;
    ownerId!: string;
    residentRegistrationStat!: ResidentRegistrationStatResponse;
    steps!: StepResponse[];
    title!: string;
    residentId!: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentRegistrationStat = new ResidentRegistrationStatResponse();
            this.steps = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.residentRegistrationStat = _data["residentRegistrationStat"] ? ResidentRegistrationStatResponse.fromJS(_data["residentRegistrationStat"]) : new ResidentRegistrationStatResponse();
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepResponse.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormStepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormStepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["residentRegistrationStat"] = this.residentRegistrationStat ? this.residentRegistrationStat.toJSON() : <any>null;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormStepResponse {
    paused: boolean;
    archived: boolean;
    description?: string | null;
    id: string;
    ownerId: string;
    residentRegistrationStat: ResidentRegistrationStatResponse;
    steps: StepResponse[];
    title: string;
    residentId: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class ResidentRegistrationStatResponse implements IResidentRegistrationStatResponse {
    registrantId!: string;
    registrationCount!: number;
    latestRegistrationTimeStamp!: moment.Moment;

    constructor(data?: IResidentRegistrationStatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrantId = _data["registrantId"] !== undefined ? _data["registrantId"] : <any>null;
            this.registrationCount = _data["registrationCount"] !== undefined ? _data["registrationCount"] : <any>null;
            this.latestRegistrationTimeStamp = _data["latestRegistrationTimeStamp"] ? moment(_data["latestRegistrationTimeStamp"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ResidentRegistrationStatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentRegistrationStatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrantId"] = this.registrantId !== undefined ? this.registrantId : <any>null;
        data["registrationCount"] = this.registrationCount !== undefined ? this.registrationCount : <any>null;
        data["latestRegistrationTimeStamp"] = this.latestRegistrationTimeStamp ? this.latestRegistrationTimeStamp.toISOString() : <any>null;
        return data; 
    }
}

export interface IResidentRegistrationStatResponse {
    registrantId: string;
    registrationCount: number;
    latestRegistrationTimeStamp: moment.Moment;
}

export class CreateRegistrationRequestBody2 implements ICreateRegistrationRequestBody2 {
    answers!: RegistrationAnswerRequest[];
    comment?: string | null;
    formId!: string;
    observedAt!: moment.Moment;
    registrantDisplayName!: string;

    constructor(data?: ICreateRegistrationRequestBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(RegistrationAnswerRequest.fromJS(item));
            }
            else {
                this.answers = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            this.registrantDisplayName = _data["registrantDisplayName"] !== undefined ? _data["registrantDisplayName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateRegistrationRequestBody2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationRequestBody2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        data["registrantDisplayName"] = this.registrantDisplayName !== undefined ? this.registrantDisplayName : <any>null;
        return data; 
    }
}

export interface ICreateRegistrationRequestBody2 {
    answers: RegistrationAnswerRequest[];
    comment?: string | null;
    formId: string;
    observedAt: moment.Moment;
    registrantDisplayName: string;
}

export class RegistrationAnswerRequest implements IRegistrationAnswerRequest {
    choiceId!: string;
    choiceOrder!: number;
    choiceScore!: number;
    choiceTitle?: string | null;
    multiSelectEnabled!: boolean;
    order!: number;
    scoringEnabled!: boolean;
    stepId!: string;
    stepTitle?: string | null;

    constructor(data?: IRegistrationAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.choiceOrder = _data["choiceOrder"] !== undefined ? _data["choiceOrder"] : <any>null;
            this.choiceScore = _data["choiceScore"] !== undefined ? _data["choiceScore"] : <any>null;
            this.choiceTitle = _data["choiceTitle"] !== undefined ? _data["choiceTitle"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
            this.stepTitle = _data["stepTitle"] !== undefined ? _data["stepTitle"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["choiceOrder"] = this.choiceOrder !== undefined ? this.choiceOrder : <any>null;
        data["choiceScore"] = this.choiceScore !== undefined ? this.choiceScore : <any>null;
        data["choiceTitle"] = this.choiceTitle !== undefined ? this.choiceTitle : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        data["stepTitle"] = this.stepTitle !== undefined ? this.stepTitle : <any>null;
        return data; 
    }
}

export interface IRegistrationAnswerRequest {
    choiceId: string;
    choiceOrder: number;
    choiceScore: number;
    choiceTitle?: string | null;
    multiSelectEnabled: boolean;
    order: number;
    scoringEnabled: boolean;
    stepId: string;
    stepTitle?: string | null;
}

export class FolderResponse implements IFolderResponse {
    id!: string;
    name!: string;
    ownerId!: string;
    customerId!: string;

    constructor(data?: IFolderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): FolderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        return data; 
    }
}

export interface IFolderResponse {
    id: string;
    name: string;
    ownerId: string;
    customerId: string;
}

export class CopyFoldersAndContentRequest implements ICopyFoldersAndContentRequest {
    sourceCustomerId!: string;
    destinationCustomerId!: string;
    destinationOwnerId!: string;
    folderIds!: string[];

    constructor(data?: ICopyFoldersAndContentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.folderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCustomerId = _data["sourceCustomerId"] !== undefined ? _data["sourceCustomerId"] : <any>null;
            this.destinationCustomerId = _data["destinationCustomerId"] !== undefined ? _data["destinationCustomerId"] : <any>null;
            this.destinationOwnerId = _data["destinationOwnerId"] !== undefined ? _data["destinationOwnerId"] : <any>null;
            if (Array.isArray(_data["folderIds"])) {
                this.folderIds = [] as any;
                for (let item of _data["folderIds"])
                    this.folderIds!.push(item);
            }
            else {
                this.folderIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CopyFoldersAndContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFoldersAndContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCustomerId"] = this.sourceCustomerId !== undefined ? this.sourceCustomerId : <any>null;
        data["destinationCustomerId"] = this.destinationCustomerId !== undefined ? this.destinationCustomerId : <any>null;
        data["destinationOwnerId"] = this.destinationOwnerId !== undefined ? this.destinationOwnerId : <any>null;
        if (Array.isArray(this.folderIds)) {
            data["folderIds"] = [];
            for (let item of this.folderIds)
                data["folderIds"].push(item);
        }
        return data; 
    }
}

export interface ICopyFoldersAndContentRequest {
    sourceCustomerId: string;
    destinationCustomerId: string;
    destinationOwnerId: string;
    folderIds: string[];
}

export class CreateFormIdResponse implements ICreateFormIdResponse {
    formId!: string;

    constructor(data?: ICreateFormIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFormIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        return data; 
    }
}

export interface ICreateFormIdResponse {
    formId: string;
}

export class CreateFormRequest implements ICreateFormRequest {
    ownerId!: string;
    title!: string;

    constructor(data?: ICreateFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface ICreateFormRequest {
    ownerId: string;
    title: string;
}

export class FormResponse implements IFormResponse {
    archived!: boolean;
    description?: string | null;
    id!: string;
    ownerId!: string;
    title!: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormResponse {
    archived: boolean;
    description?: string | null;
    id: string;
    ownerId: string;
    title: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class GetFormsByIdBatchRequest implements IGetFormsByIdBatchRequest {
    formIds!: string[];

    constructor(data?: IGetFormsByIdBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsByIdBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsByIdBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsByIdBatchRequest {
    formIds: string[];
}

export class GetFormsForOwnersBatchRequest implements IGetFormsForOwnersBatchRequest {
    includeArchived!: boolean;
    ownerIds!: string[];

    constructor(data?: IGetFormsForOwnersBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ownerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"] !== undefined ? _data["includeArchived"] : <any>null;
            if (Array.isArray(_data["ownerIds"])) {
                this.ownerIds = [] as any;
                for (let item of _data["ownerIds"])
                    this.ownerIds!.push(item);
            }
            else {
                this.ownerIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsForOwnersBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsForOwnersBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived !== undefined ? this.includeArchived : <any>null;
        if (Array.isArray(this.ownerIds)) {
            data["ownerIds"] = [];
            for (let item of this.ownerIds)
                data["ownerIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsForOwnersBatchRequest {
    includeArchived: boolean;
    ownerIds: string[];
}

export class GetFormsForOwnersBatchInternalRequest extends GetFormsForOwnersBatchRequest implements IGetFormsForOwnersBatchInternalRequest {
    customerId!: string;

    constructor(data?: IGetFormsForOwnersBatchInternalRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): GetFormsForOwnersBatchInternalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsForOwnersBatchInternalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IGetFormsForOwnersBatchInternalRequest extends IGetFormsForOwnersBatchRequest {
    customerId: string;
}

export class FormAssignmentResponse implements IFormAssignmentResponse {
    paused!: boolean;
    activeForResident!: boolean;
    assignedToResidentId!: string;
    archived!: boolean;
    id!: string;
    ownerId!: string;
    residentExtendedStepCount!: number;
    title!: string;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.assignedToResidentId = _data["assignedToResidentId"] !== undefined ? _data["assignedToResidentId"] : <any>null;
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.residentExtendedStepCount = _data["residentExtendedStepCount"] !== undefined ? _data["residentExtendedStepCount"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["assignedToResidentId"] = this.assignedToResidentId !== undefined ? this.assignedToResidentId : <any>null;
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["residentExtendedStepCount"] = this.residentExtendedStepCount !== undefined ? this.residentExtendedStepCount : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormAssignmentResponse {
    paused: boolean;
    activeForResident: boolean;
    assignedToResidentId: string;
    archived: boolean;
    id: string;
    ownerId: string;
    residentExtendedStepCount: number;
    title: string;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class GetFormsWithAssignmentsIncludedByQueryBodyRequest implements IGetFormsWithAssignmentsIncludedByQueryBodyRequest {
    includeArchived!: boolean;
    residentIds!: string[];

    constructor(data?: IGetFormsWithAssignmentsIncludedByQueryBodyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"] !== undefined ? _data["includeArchived"] : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsWithAssignmentsIncludedByQueryBodyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsWithAssignmentsIncludedByQueryBodyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived !== undefined ? this.includeArchived : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsWithAssignmentsIncludedByQueryBodyRequest {
    includeArchived: boolean;
    residentIds: string[];
}

export class SetFormArchivedStatusRequest implements ISetFormArchivedStatusRequest {
    archived!: boolean;

    constructor(data?: ISetFormArchivedStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
        }
    }

    static fromJS(data: any): SetFormArchivedStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetFormArchivedStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        return data; 
    }
}

export interface ISetFormArchivedStatusRequest {
    archived: boolean;
}

export class UpdateFormRequest implements IUpdateFormRequest {
    title!: string;
    description?: string | null;
    folderId?: string | null;
    descriptiveImage?: DescriptiveImage2 | null;
    accessControlTagIds!: string[];

    constructor(data?: IUpdateFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
            this.descriptiveImage = _data["descriptiveImage"] ? DescriptiveImage2.fromJS(_data["descriptiveImage"]) : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        data["descriptiveImage"] = this.descriptiveImage ? this.descriptiveImage.toJSON() : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateFormRequest {
    title: string;
    description?: string | null;
    folderId?: string | null;
    descriptiveImage?: DescriptiveImage2 | null;
    accessControlTagIds: string[];
}

export class DescriptiveImage2 implements IDescriptiveImage2 {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;

    constructor(data?: IDescriptiveImage2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagePath = _data["imagePath"] !== undefined ? _data["imagePath"] : <any>null;
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.deleteImage = _data["deleteImage"] !== undefined ? _data["deleteImage"] : <any>null;
        }
    }

    static fromJS(data: any): DescriptiveImage2 {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptiveImage2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagePath"] = this.imagePath !== undefined ? this.imagePath : <any>null;
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["deleteImage"] = this.deleteImage !== undefined ? this.deleteImage : <any>null;
        return data; 
    }
}

export interface IDescriptiveImage2 {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;
}

export class SetFutureAssignmentsRequest implements ISetFutureAssignmentsRequest {
    assignedAndEnabledForEmployeesOnFutureResidents!: boolean;
    assignedAndEnabledForResidentsOnFutureResidents!: boolean;

    constructor(data?: ISetFutureAssignmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedAndEnabledForEmployeesOnFutureResidents = _data["assignedAndEnabledForEmployeesOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForEmployeesOnFutureResidents"] : <any>null;
            this.assignedAndEnabledForResidentsOnFutureResidents = _data["assignedAndEnabledForResidentsOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForResidentsOnFutureResidents"] : <any>null;
        }
    }

    static fromJS(data: any): SetFutureAssignmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetFutureAssignmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAndEnabledForEmployeesOnFutureResidents"] = this.assignedAndEnabledForEmployeesOnFutureResidents !== undefined ? this.assignedAndEnabledForEmployeesOnFutureResidents : <any>null;
        data["assignedAndEnabledForResidentsOnFutureResidents"] = this.assignedAndEnabledForResidentsOnFutureResidents !== undefined ? this.assignedAndEnabledForResidentsOnFutureResidents : <any>null;
        return data; 
    }
}

export interface ISetFutureAssignmentsRequest {
    assignedAndEnabledForEmployeesOnFutureResidents: boolean;
    assignedAndEnabledForResidentsOnFutureResidents: boolean;
}

export class AssignedForFutureResidentsResponse implements IAssignedForFutureResidentsResponse {
    assignedAndEnabledForEmployeesOnFutureResidents!: boolean;
    assignedAndEnabledForResidentsOnFutureResidents!: boolean;

    constructor(data?: IAssignedForFutureResidentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedAndEnabledForEmployeesOnFutureResidents = _data["assignedAndEnabledForEmployeesOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForEmployeesOnFutureResidents"] : <any>null;
            this.assignedAndEnabledForResidentsOnFutureResidents = _data["assignedAndEnabledForResidentsOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForResidentsOnFutureResidents"] : <any>null;
        }
    }

    static fromJS(data: any): AssignedForFutureResidentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedForFutureResidentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAndEnabledForEmployeesOnFutureResidents"] = this.assignedAndEnabledForEmployeesOnFutureResidents !== undefined ? this.assignedAndEnabledForEmployeesOnFutureResidents : <any>null;
        data["assignedAndEnabledForResidentsOnFutureResidents"] = this.assignedAndEnabledForResidentsOnFutureResidents !== undefined ? this.assignedAndEnabledForResidentsOnFutureResidents : <any>null;
        return data; 
    }
}

export interface IAssignedForFutureResidentsResponse {
    assignedAndEnabledForEmployeesOnFutureResidents: boolean;
    assignedAndEnabledForResidentsOnFutureResidents: boolean;
}

export class UpdatePlanAndResidentRelationsRequest implements IUpdatePlanAndResidentRelationsRequest {
    formIdsToAdd!: string[];
    formIdsToRemove!: string[];

    constructor(data?: IUpdatePlanAndResidentRelationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIdsToAdd = [];
            this.formIdsToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIdsToAdd"])) {
                this.formIdsToAdd = [] as any;
                for (let item of _data["formIdsToAdd"])
                    this.formIdsToAdd!.push(item);
            }
            else {
                this.formIdsToAdd = <any>null;
            }
            if (Array.isArray(_data["formIdsToRemove"])) {
                this.formIdsToRemove = [] as any;
                for (let item of _data["formIdsToRemove"])
                    this.formIdsToRemove!.push(item);
            }
            else {
                this.formIdsToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdatePlanAndResidentRelationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanAndResidentRelationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIdsToAdd)) {
            data["formIdsToAdd"] = [];
            for (let item of this.formIdsToAdd)
                data["formIdsToAdd"].push(item);
        }
        if (Array.isArray(this.formIdsToRemove)) {
            data["formIdsToRemove"] = [];
            for (let item of this.formIdsToRemove)
                data["formIdsToRemove"].push(item);
        }
        return data; 
    }
}

export interface IUpdatePlanAndResidentRelationsRequest {
    formIdsToAdd: string[];
    formIdsToRemove: string[];
}

export class FormsQueryRequest implements IFormsQueryRequest {
    formId!: string;
    residentId!: string;

    constructor(data?: IFormsQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): FormsQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormsQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IFormsQueryRequest {
    formId: string;
    residentId: string;
}

export class CopyFormsRequest implements ICopyFormsRequest {
    sourceCustomerId!: string;
    destinationCustomerId!: string;
    destinationOwnerId!: string;
    formIds!: string[];

    constructor(data?: ICopyFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCustomerId = _data["sourceCustomerId"] !== undefined ? _data["sourceCustomerId"] : <any>null;
            this.destinationCustomerId = _data["destinationCustomerId"] !== undefined ? _data["destinationCustomerId"] : <any>null;
            this.destinationOwnerId = _data["destinationOwnerId"] !== undefined ? _data["destinationOwnerId"] : <any>null;
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CopyFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCustomerId"] = this.sourceCustomerId !== undefined ? this.sourceCustomerId : <any>null;
        data["destinationCustomerId"] = this.destinationCustomerId !== undefined ? this.destinationCustomerId : <any>null;
        data["destinationOwnerId"] = this.destinationOwnerId !== undefined ? this.destinationOwnerId : <any>null;
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface ICopyFormsRequest {
    sourceCustomerId: string;
    destinationCustomerId: string;
    destinationOwnerId: string;
    formIds: string[];
}

export class CreateFolderRequest implements ICreateFolderRequest {
    ownerId!: string;
    name!: string;

    constructor(data?: ICreateFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface ICreateFolderRequest {
    ownerId: string;
    name: string;
}

export class UpdateFolderRequest implements IUpdateFolderRequest {
    name!: string;

    constructor(data?: IUpdateFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IUpdateFolderRequest {
    name: string;
}

export class CreateChoiceRequest implements ICreateChoiceRequest {
    imageData!: string;
    score!: number;
    title?: string | null;

    constructor(data?: ICreateChoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface ICreateChoiceRequest {
    imageData: string;
    score: number;
    title?: string | null;
}

export class UpdateChoicesRequest implements IUpdateChoicesRequest {
    choices!: ChoiceRequest[];

    constructor(data?: IUpdateChoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.choices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceRequest.fromJS(item));
            }
            else {
                this.choices = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateChoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateChoicesRequest {
    choices: ChoiceRequest[];
}

export class ChoiceRequest implements IChoiceRequest {
    choiceId!: string;
    orderIndex!: number;
    score!: number;
    title!: string;

    constructor(data?: IChoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ChoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface IChoiceRequest {
    choiceId: string;
    orderIndex: number;
    score: number;
    title: string;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "Ambiguous",
    Ambiguous = "Ambiguous",
    MovedPermanently = "Moved",
    Moved = "Moved",
    Found = "Redirect",
    Redirect = "Redirect",
    SeeOther = "RedirectMethod",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class DeleteAssignmentBulkRequest implements IDeleteAssignmentBulkRequest {
    residentIds!: string[];

    constructor(data?: IDeleteAssignmentBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteAssignmentBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssignmentBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IDeleteAssignmentBulkRequest {
    residentIds: string[];
}

export class AssignmentResponse implements IAssignmentResponse {
    paused!: boolean;
    activeForResident!: boolean;
    draft!: boolean;
    residentId!: string;

    constructor(data?: IAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["draft"] = this.draft !== undefined ? this.draft : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IAssignmentResponse {
    paused: boolean;
    activeForResident: boolean;
    draft: boolean;
    residentId: string;
}

export class GetResidentsIdsAssignedToFormIdsBulkRequest implements IGetResidentsIdsAssignedToFormIdsBulkRequest {
    formIds!: string[];

    constructor(data?: IGetResidentsIdsAssignedToFormIdsBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetResidentsIdsAssignedToFormIdsBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResidentsIdsAssignedToFormIdsBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface IGetResidentsIdsAssignedToFormIdsBulkRequest {
    formIds: string[];
}

export class AssignmentRequest implements IAssignmentRequest {
    paused?: boolean | null;
    activeForResident!: boolean;
    draft!: boolean;

    constructor(data?: IAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["draft"] = this.draft !== undefined ? this.draft : <any>null;
        return data; 
    }
}

export interface IAssignmentRequest {
    paused?: boolean | null;
    activeForResident: boolean;
    draft: boolean;
}

export class UpdateAssignmentsBulkRequest implements IUpdateAssignmentsBulkRequest {
    assignments!: AssignmentForResidentRequest[];

    constructor(data?: IUpdateAssignmentsBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(AssignmentForResidentRequest.fromJS(item));
            }
            else {
                this.assignments = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateAssignmentsBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssignmentsBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateAssignmentsBulkRequest {
    assignments: AssignmentForResidentRequest[];
}

export class AssignmentForResidentRequest implements IAssignmentForResidentRequest {
    paused?: boolean | null;
    activeForResident!: boolean;
    draft!: boolean;
    residentId!: string;

    constructor(data?: IAssignmentForResidentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentForResidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentForResidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["draft"] = this.draft !== undefined ? this.draft : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IAssignmentForResidentRequest {
    paused?: boolean | null;
    activeForResident: boolean;
    draft: boolean;
    residentId: string;
}

export class AnswerBatchRequestBody implements IAnswerBatchRequestBody {
    registrationIds!: string[];

    constructor(data?: IAnswerBatchRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrationIds"])) {
                this.registrationIds = [] as any;
                for (let item of _data["registrationIds"])
                    this.registrationIds!.push(item);
            }
            else {
                this.registrationIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerBatchRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerBatchRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrationIds)) {
            data["registrationIds"] = [];
            for (let item of this.registrationIds)
                data["registrationIds"].push(item);
        }
        return data; 
    }
}

export interface IAnswerBatchRequestBody {
    registrationIds: string[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}